// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Desktop {
    background-color: #f8f9fa;
}

#resultado-titulo {

    font-weight: bold;
    font-size: 4rem;
    text-align: center;
    margin-top: 20px;
}

.resultado-container {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/styles/Resultado.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".Desktop {\n    background-color: #f8f9fa;\n}\n\n#resultado-titulo {\n\n    font-weight: bold;\n    font-size: 4rem;\n    text-align: center;\n    margin-top: 20px;\n}\n\n.resultado-container {\n    padding: 20px 0;\n    display: flex;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
